import { render, staticRenderFns } from "./rightsList.vue?vue&type=template&id=c528806c"
import script from "./rightsList.vue?vue&type=script&lang=js"
export * from "./rightsList.vue?vue&type=script&lang=js"
import style0 from "./rightsList.vue?vue&type=style&index=0&id=c528806c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports